<template>
  <div :style="{ zIndex: zIndex, display: hidden ? 'none' : 'block' }" @touchmove.prevent>
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast" :class="{'no-min-height': type === 'none',  'title-box': title && !toastType}">
      <i v-if="toastType" :class="`${toastType} weui-icon_toast`" />
      <p class="weui-toast__content weui-toast__title" v-if="title">{{ title }}</p>
      <p class="weui-toast__content" v-if="message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
let zIndex = 1000
export default {
  name: 'Toast',
  data () {
    return {
      message: '已完成',
      type: 'success',
      showTime: null,
      zIndex: zIndex++,
      resolve: null,
      isMounted: false,
      hidden: false,
      tick: null,
      title: ''
    }
  },
  computed: {
    toastType () {
      const { type } = this
      switch (type) {
        case 'success': {
          return 'weui-icon-success-no-circle'
        }
        case 'loading': {
          return 'weui-loading'
        }
        case 'network': {
          return 'icon-wifi'
        }
        default:
          return ''
      }
    }
  },
  methods: {
    close () {
      if (this.resolve !== null) this.resolve()
      this.showTime = null
      this.resolve = null
      this.hide()
    },
    show () {
      this.hidden = false
      if (typeof this.showTime === 'number') {
        clearTimeout(this.tick)
        this.tick = setTimeout(() => {
          this.close()
        }, this.showTime)
      }
    },
    hide () {
      this.hidden = true
    }
  },
  mounted () {
    if (!this.isMounted) this.isMounted = true
    const self = this;
    window.addEventListener('hashchange', function (event) {
      self.close();
    }, false);
  }
}
</script>

<style scoped>
.no-min-height {
  min-height: initial;
}
.weui-icon_toast {
  width: 1rem;
  height: 1rem;
}
.title-box {
  margin-left: -3rem;
  width: 6rem;
  height: 1.2rem;
  padding-top: .8rem;
}
.weui-toast__title {
  font-size: 16px;
  font-weight: 600
}
</style>
